module.exports = __webpack_public_path__ + "static/media/wakatuki_ren_updateca03c8678312abd1a717507f0b53e2b8.webp";